import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import WOW from "wowjs";

export default function RecentBlog() {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        axios.get('https://solanthegroup.com/admin/api/blogs')
            .then(response => {
                setBlogs(response.data);
            })
            .catch(error => {
                console.error("Error fetching recent blog posts:", error);
            });
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };


    return (
        <div>
            <div className="single-footer-wrapper pr--15">
                <h5 className="ft-title">Recent Post</h5>
                {blogs.length > 0 ? (
                    blogs.slice(0, 2).map((blog) => (
                        <div className="single-post">
                            <div className="thumbnail">
                                <img
                                    src={`https://solanthegroup.com/admin/${blog.banner}`}
                                    alt="Business_Corporate"
                                    className='w-75'
                                />
                            </div>
                            <div className="content">
                                <div className="date">
                                    <i className="fa-light fa-calendar-days" />
                                    <span>{formatDate(blog.created_at)}</span>
                                </div>
                                <Link to={`/BlogDetails?id=${blog.id}`}>
                                    <h6 className="title text-justify">
                                    {blog.title.split(" ").slice(0, 8).join(" ")}{blog.title.split(" ").length > 8 ? "..." : ""}
                                    </h6>
                                </Link>
                            </div>
                        </div>
                    ))
                ) : (
                    <p></p>
                )}
            </div>
            <style>
                {`
                .single-footer-wrapper .single-post {
                    gap: 0px!important; 
                }
                .single-footer-wrapper .single-post .thumbnail img {
                    min-width: 100%!important; 
                }
                `}
            </style>
        </div>
    )
}
